import gql from 'graphql-tag';

export default gql`
fragment ProductAttributeAllData on ProductAttribute {
    id
    name
    code
    filterable
    is_active
    type
    options {
        id
        label
        position
        is_active
        is_default
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/ProductAttributeAllData.ts